module.exports = "https://trybtryb-legacy.web.app/img/support.b15eb4de.webp";